import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupCreateShopNewPage } from './shopper-social-group-create-shop-new';

@NgModule({
  declarations: [
    ShopperSocialGroupCreateShopNewPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupCreateShopNewPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupCreateShopNewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-create-shop-new/shopper-social-group-create-shop-new.module.ts